export default "__VITE_ASSET__f45d2245__"